import { Button, Typography } from "@repo/design-system";
import type { IActiveFilterChip } from "../hooks";

interface IActiveFiltersBarProps {
  chips: IActiveFilterChip[];
  onClearAll: () => void;
}

export function ActiveFiltersBar({
  chips,
  onClearAll,
}: IActiveFiltersBarProps) {
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-shrink-0 flex-wrap items-center gap-2 rounded-lg border border-borderPrimary bg-backgroundSecondary px-3 py-2">
      <Typography
        variant="paragraph-m-semibold"
        className="whitespace-nowrap text-contentSecondary">
        Active filters:
      </Typography>

      {chips.map((chip) => (
        <div
          key={chip.key}
          className="flex items-center gap-1 rounded-pill border border-borderPrimary bg-backgroundPrimary py-1 pl-2.5 pr-1">
          <Typography
            variant="paragraph-m-medium"
            className="text-contentPrimary">
            {chip.label}
          </Typography>
          <Button
            variant="transparent"
            size="small"
            leftIcon="close"
            className="p-0.5"
            onPress={chip.onRemove}
          />
        </div>
      ))}

      <Button
        variant="transparent"
        size="small"
        onPress={onClearAll}
        className="ms-auto text-contentBrand">
        Clear all
      </Button>
    </div>
  );
}
